import { render, staticRenderFns } from "./ViewPackages.vue?vue&type=template&id=0c39b206"
import script from "./ViewPackages.vue?vue&type=script&lang=js"
export * from "./ViewPackages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports